/**
 * Token de sesión — en memoria durante toda la vida de la pestaña, más un respaldo persistente
 * SOLO para el modo navegador externo (P0.54).
 *
 * Dentro de Telegram WebApp (`lib/telegram.ts::isInsideTelegram()` true) la Mini App revalida
 * `initData` fresco cada vez que Telegram la reabre, así que el token en memoria basta — nunca
 * se lee el respaldo persistente en ese modo (Sección 11 del encargo P0.54: los dos modos
 * conviven, pero cada uno prioriza su propia fuente de verdad).
 *
 * Fuera de Telegram (login con Telegram Login Widget), SÍ hace falta sobrevivir a un refresh
 * del navegador (Sección 30/36 del encargo) — por eso el token también se guarda en
 * `localStorage` bajo una clave propia, nunca mezclada con ningún otro dato de la app.
 */

let currentToken: string | null = null

const BROWSER_SESSION_STORAGE_KEY = 'ja_client_web_session_token'

export function setSessionToken(token: string | null): void {
  currentToken = token
}

export function getSessionToken(): string | null {
  return currentToken
}

export function clearSession(): void {
  currentToken = null
}

/** Respaldo persistente -- SOLO para el flujo de login por navegador (P0.54). Nunca se llama
 * desde el flujo de Telegram WebApp. */
export function persistBrowserSessionToken(token: string): void {
  try {
    localStorage.setItem(BROWSER_SESSION_STORAGE_KEY, token)
  } catch {
    // localStorage no disponible (modo privado estricto, cuota agotada, etc.) -- la sesión
    // sigue funcionando en memoria durante esta pestaña, simplemente no sobrevive a un refresh.
  }
}

export function getPersistedBrowserSessionToken(): string | null {
  try {
    return localStorage.getItem(BROWSER_SESSION_STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearPersistedBrowserSessionToken(): void {
  try {
    localStorage.removeItem(BROWSER_SESSION_STORAGE_KEY)
  } catch {
    // noop
  }
}
